<template>
  <div id="confirm_infors_outer" v-if="coachModel != null">
    <div>
      <h4 class="main-title">基本信息</h4>
      <div class="display-row">
        <div class="column left-label">*姓名：</div>
        <div class="column border-line" >{{coachModel.coach.name}}</div>
      </div>

      <div class="display-row">
        <div class="column left-label">*性别：</div>
        <div class="column border-line" >{{coachModel.coach.sex}}</div>
      </div>

      <div class="display-row">
        <div class="column left-label picture-upload-label">*个人照片：</div>
        <div class="column" >
          <el-image :src="coachModel.coach.photo" fit="fill" class="picture-item" :preview-src-list="[coachModel.coach.photo]" />
        </div>
      </div>

      <div class="display-row">
        <div class="column left-label">*身高：</div>
        <div class="column border-line" >{{coachModel.coach.height + 'CM'}}</div>
      </div>

      <div class="display-row">
        <div class="column left-label">*体重：</div>
        <div class="column border-line" >{{coachModel.coach.weight + 'KG'}}</div>
      </div>

      <div class="display-row">
        <div class="column left-label">*所属区：</div>
        <div class="column border-line" >{{coachModel.coach.area}}</div>
      </div>

      <div class="display-row">
        <div class="column left-label">*身份证号：</div>
        <div class="column border-line" >{{coachModel.coach.idNo}}</div>
      </div>

      <div class="display-row">
        <div class="column left-label">*联系电话：</div>
        <div class="column border-line" >{{coachModel.coach.mobile}}</div>
      </div>

      <div class="display-row">
        <div class="column left-label">*工作单位：</div>
        <div class="column border-line" >{{coachModel.coach.unit}}</div>
      </div>

      <div class="display-row">
        <div class="column left-label">*职位：</div>
        <div class="column border-line" >{{coachModel.coach.position}}</div>
      </div>

      <div class="display-row">
        <div class="column left-label">*政治面貌：</div>
        <div class="column border-line" >{{coachModel.coach.political}}</div>
      </div>

      <div class="display-row">
        <div class="column left-label">*最高学历：</div>
        <div class="column border-line" >{{coachModel.coach.education}}</div>
      </div>

      <div class="display-row">
        <div class="column left-label">*毕业院校：</div>
        <div class="column border-line" >{{coachModel.coach.school}}</div>
      </div>

      <div class="display-row">
        <div class="column left-label">*毕业时间：</div>
        <div class="column border-line" >{{$moment(coachModel.coach.outOfSchool).format("yyyy-MM")}}</div>
      </div>

      <div class="display-row">
        <div class="column left-label">*电子邮箱：</div>
        <div class="column border-line" >{{coachModel.coach.email}}</div>
      </div>

      <div class="display-row">
        <div class="column left-label">*邮寄地址：</div>
        <div class="column border-line" >{{coachModel.coach.addr}}</div>
      </div>

      <h4 class="main-title">资格信息</h4>
      <div class="display-card-item"
      v-for="(certItem, index) in coachModel.certificates"
      :key="'cert_card_' + index">
        <h4 style="margin-bottom: 15px;">证书{{index+1}}</h4>
        <div class="display-row">
          <div class="column left-label">*证书名称：</div>
          <div class="column border-line" >{{certItem.name}}</div>
        </div>

        <div class="display-row">
          <div class="column left-label">*证书等级：</div>
          <div class="column border-line" >{{certItem.level}}</div>
        </div>

        <div class="display-row">
          <div class="column left-label">*证书编号：</div>
          <div class="column border-line" >{{certItem.sn}}</div>
        </div>

        <div class="display-row">
          <div class="column left-label">*证书签发日期：</div>
          <div class="column border-line" >{{$moment(certItem.dateOfIssue).format("yyyy-MM-DD")}}</div>
        </div>

        <div class="display-row">
          <div class="column left-label">*发证单位：</div>
          <div class="column border-line" >{{certItem.unit}}</div>
        </div>

        <div class="display-row">
          <div class="column left-label picture-upload-label">*证书照片：</div>
          <div class="column" >
            <el-image
             v-for="(pictureItem, index) in certItem.photos"
             :key="'cert_image_' + index"
             :src="pictureItem" fit="fill" class="picture-item" :preview-src-list="[certItem.photos]" />
          </div>
        </div>
      </div>

      <h4 class="main-title">执教履历</h4>

      <div class="display-card-item"
      v-for="(resumeItem, index) in coachModel.resumes"
      :key="'teaching_card_' + index">
        <h4 style="margin-bottom: 15px;">履历{{index+1}}</h4>

        <div class="display-row">
          <div class="column left-label">*执教单位：</div>
          <div class="column border-line" >{{resumeItem.unit}}</div>
        </div>

        <div class="display-row">
          <div class="column left-label">*执教职位：</div>
          <div class="column border-line" >{{resumeItem.title}}</div>
        </div>

        <div class="display-row">
          <div class="column left-label">*开始时间：</div>
          <div class="column border-line" >{{$moment(resumeItem.beginDate).format("yyyy-MM-DD")}}</div>
        </div>

        <div class="display-row">
          <div class="column left-label">*结束时间：</div>
          <div class="column border-line" >{{resumeItem.endDate == null ? '至今' :  $moment(resumeItem.endDate).format("yyyy-MM-DD")}}</div>
        </div>

        <div v-if="resumeItem.results != null && resumeItem.results.length > 0" class="display-row">
          <div class="column left-label">期间获得的成绩：</div>
          <div class="column border-line" >{{resumeItem.results}}</div>
        </div>

        <div class="display-row" v-if="resumeItem.photos.length > 0">
          <div class="column left-label picture-upload-label">成绩证明：</div>
          <div class="column" >
            <el-image
             v-for="(pictureItem, index) in resumeItem.photos"
             :key="'teaching_image_' + index"
             :src="pictureItem" fit="fill" class="picture-item" :preview-src-list="[resumeItem.photos]" />
          </div>
        </div>
      </div>

      <h4 class="main-title">参培经历</h4>
      <div class="display-card-item"
      v-for="(cultivateItem, index) in coachModel.cultivates"
      :key="'training_card_' + index">
        <h4 style="margin-bottom: 15px;">经历{{index+1}}</h4>

        <div class="display-row">
          <div class="column left-label">*培训名称：</div>
          <div class="column border-line" >{{cultivateItem.name}}</div>
        </div>

        <div class="display-row">
          <div class="column left-label">*培训单位：</div>
          <div class="column border-line" >{{cultivateItem.unit}}</div>
        </div>

        <div class="display-row">
          <div class="column left-label">*培训地点：</div>
          <div class="column border-line" >{{cultivateItem.location}}</div>
        </div>


        <div class="display-row">
          <div class="column left-label">*开始时间：</div>
          <div class="column border-line" >{{$moment(cultivateItem.beginDate).format("yyyy-MM-DD")}}</div>
        </div>

        <div class="display-row">
          <div class="column left-label">*结束时间：</div>
          <div class="column border-line" >{{$moment(cultivateItem.endDate).format("yyyy-MM-DD")}}</div>
        </div>

        <div class="display-row">
          <div class="column left-label picture-upload-label">*参培证明材料：</div>
          <div class="column" >
            <el-image
             v-for="(pictureItem, index) in cultivateItem.photos"
             :key="'training_image_' + index"
             :src="pictureItem" fit="fill" class="picture-item" :preview-src-list="[cultivateItem.photos]" />
          </div>
        </div>

      </div>

      <div style="width: 100%;text-align: center;margin-top: 50px;">
        <el-button class="bottom-button back-button" @click="backButtonClicked" round>返回修改</el-button>
        <el-button class="bottom-button next-button" @click="nextButtonClicked" round>确认提交</el-button>
      </div>

    </div>
  </div>
</template>

<script>
  import EventManager from "../../../../js/event-common.js";
  import {Loading} from "element-ui";
  export default {
    name: "ConfirmInformationVue",
    props: {
      item: {
        type: Object,
        default: null
      }
    },
    data() {
      return {
        coachModel: null,
      }
    },

    computed: {
      eventManager() {
        return this.$store.state.eventManager;
      },
      user() {
        return this.$store.state.user;
      },
      httpManager() {
        return this.$store.state.http;
      },
    },

    mounted() {
      this.initData();
    },
    methods: {
      initData() {
        let item = this.item;
        if (item != null) {
          let coachModel = {};
          let coach = item.coach;
          let certificates = item.certificates;
          let resumes = item.resumes;
          let cultivates = item.cultivates;
          coachModel.coach = {};
          for (let key in coach) {
            coachModel.coach[key] = coach[key];
          }

          coachModel.certificates = [];
          for(let i = 0; i < certificates.length; i++) {
            let item = certificates[i];
            let certItem = {};
            for (let key in item) {
              if (key == 'photo') {
                let value = item['photo'];
                let photos = value.split(",");
                certItem.photos = photos;
              } else {
                certItem[key] = item[key];
              }
            }
            coachModel.certificates.push(certItem);
          }

          coachModel.resumes = [];
          for(let i = 0; i < resumes.length; i++) {
            let item = resumes[i];
            let resumeItem = {};
            for (let key in item) {
              if (key == 'photo') {
                let value = item['photo'];
                if (value != null && value.length > 0) {
                  let photos = value.split(",");
                  resumeItem.photos = photos;
                } else {
                  resumeItem.photos = [];
                }
              } else {
                resumeItem[key] = item[key];
              }
            }
            coachModel.resumes.push(resumeItem);
          }

          coachModel.cultivates = [];
          for(let i = 0; i < cultivates.length; i++) {
            let item = cultivates[i];
            let cultivateItem = {};
            for (let key in item) {
              if (key == 'photo') {
                let value = item['photo'];
                let photos = value.split(",");
                cultivateItem.photos = photos;
              } else {
                cultivateItem[key] = item[key];
              }
            }
            coachModel.cultivates.push(cultivateItem);
          }
          this.coachModel = coachModel;
        }
      },

      updateStatus(status, success, failure) {
        let params = {};
        let coachItem = this.item;
        params.status = status;
        params.auditStatus = 1;
        params.id = coachItem.coach.id;
        this.httpManager.ajax.postCoachStatusUpdateRequest(params, function(data) {
          console.log(data);
          console.log('upate coach status succeed!');
          let code = data.code;
          if (code == 0) {
            success();
            return;
          }
          failure(data);
        }, function(data) {
          failure(data);
        });
      },
      backButtonClicked() {
        this.$emit('backToEidtPage');
      },
      nextButtonClicked() {
        if (this.item == null) {
          this.$toast('页面数据错误！');
          return;
        }
        let coach = this.item.coach;
        if (coach == null) {
          this.$toast('页面数据错误！');
          return;
        }
        let user = this.user;
        if (user == null) {
          this.$toast('页面数据错误！');
          return;
        }
        let idNo = user.idNumber;
        let name = user.name;
        let status = 5;
        if (name == coach.name && idNo == coach.idNo && user.isIdentification > 0) {
          status = 6;
        }

        console.log('status = ' + status);
        let _this = this;
        let loadFlags = Loading.service({
          target: document.getElementById('app'),
          fullscreen: true
        });
        this.updateStatus(status, function() {
          loadFlags.close();
          _this.eventManager.postNotification(EventManager.notificationNameObject.updateCoachData, null);
        }, function(data) {
          loadFlags.close();
          console.log('update status failed!');
          _this.$toast("提交失败！");
        });
      },
    }
  }
</script>

<style scoped>
  @import url("../../../../css/display-row.css");
  @import url("../../../../css/back-next-buttons.css");
  #confirm_infors_outer {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-items: center;
  }

  #confirm_infors_outer > div {
    width: 100%;
    max-width: 900px;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-items: center;
  }

  #confirm_infors_outer .main-title {
    margin-bottom: 30px;
    margin-top: 20px;
  }

  #confirm_infors_outer .main-title:first-child {
    margin-top: 30px;
  }

  #confirm_infors_outer .display-card-item {
    margin-bottom: 30px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-wrap: nowrap;
  }

  #confirm_infors_outer .display-card-item:last-child {
    margin-bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/personal/coachApplications/children/ConfirmInformation.vue